(function () {
  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function initCountdown(countdown) {
    if (!countdown || countdown.dataset.listicleCountdownReady === 'true') return;

    var endDate = countdown.dataset.endDate;
    if (!endDate) return;

    countdown.dataset.listicleCountdownReady = 'true';

    var target = new Date(endDate.replace(' ', 'T')).getTime();
    var daysEl = countdown.querySelector('[data-days]');
    var hoursEl = countdown.querySelector('[data-hours]');
    var minutesEl = countdown.querySelector('[data-minutes]');
    var secondsEl = countdown.querySelector('[data-seconds]');

    function update() {
      var now = Date.now();
      var distance = Math.max(0, target - now);
      var days = Math.floor(distance / 86400000);
      var hours = Math.floor((distance % 86400000) / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    update();
    window.setInterval(update, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-listicle-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
